import { render } from "./markdown_text_area.vue?vue&type=template&id=054b0770"
import script from "./markdown_text_area.vue?vue&type=script&lang=js"
export * from "./markdown_text_area.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__